module.exports = __webpack_public_path__ + "img/social-review-logo.png";